import { CoursesService } from '@/services/plataforma/courses';
import { Reports } from '@/services/reports/reports';
import { ContentService } from '@/services/plataforma/content';
import { ContentServiceV2 } from '@/services/plataforma/contentv2/content';
import { ContentImportService } from '@/services/plataforma/contentv2/contentImport';
import { MessageService } from '@/services/messages/messages';
import { GroupSet } from '@/services/plataforma/groupset';
import { States } from '@/services/plataforma/states';
import { CategoriesService } from '@/services/plataforma/categories';
import Notices from '@/services/communication/notices';
import Dashboards from '@/services/communication/dashboards';
import { Calendar } from '@/services/communication/calendar';
import { PermissionsService } from '@/services/plataforma/permissions';
import { TagsService } from '@/services/plataforma/tags';
import { GradesService  } from '@/services/plataforma/grades';
import { Achievements } from '@/services/plataforma/achievements';
import { UserService } from '@/services/plataforma/user';
import { PeriodService } from '@/services/plataforma/periods';
import { EnrollmentUser } from '@/services/plataforma/enrollment/user';

export default [
  Reports,
  ContentService,
  ContentServiceV2,
  ContentImportService,
  CoursesService,
  TagsService,
  MessageService,
  GradesService,
  CategoriesService,
  Notices,
  GroupSet,
  States,
  PermissionsService,
  UserService,
  PeriodService,
  Dashboards,
  Calendar,
  Achievements,
  UserService,
  EnrollmentUser
];
